<template>
    <content-view class="companyOrderCreate" ref="companyOrderCreate">
        <div slot="header" class="ml16 companyOrderCreate-title">
            <div class="companyOrderCreate-title-tips">
                <span>兑换ID: </span>
                <span>{{dataDetail.couponId}};</span>
                <span>兑换礼券名称：</span>
                <span>{{dataDetail.couponName}}；</span>
                <span>兑换有效期：</span>
                <span v-if="dataDetail.isHasExpiryDate == 0">不限期；</span>
                <span v-else-if="dataDetail.isHasExpiryDate == 1">{{dataDetail.startExpiryDate}} ~ {{dataDetail.endExpiryDate}}；</span>
                <span v-else>-；</span>
                <span>兑换礼券状态：</span>
                <span>{{dataDetail.status == '-1' ? '停用' : '正常'}}；</span>
                <span>是否享受买赠：</span>
                <span>{{["否", "是"][dataDetail.isHasBuyGet]}}；</span>
            </div>
            <exchangeGoods title="" :shops="false" :goodsDetail="dataDetail" :bordered="false" :goodsId="dataDetail.goodId" :goodsType="dataDetail.goodCategory"> </exchangeGoods>
        </div>
        <div style="companyOrderCreate-content" v-if="noTitleKey==1">
            <a-card
                :bordered="false"
                title="基础信息"
            >
                <a-form :form="form" class="store-one-form">
                    <a-row>
                        <a-col span="8">
                            <a-form-item label="客户名称" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-input placeholder="请输入" v-decorator="['consumerName', {rules:[{required: true, message: '请输入'}]}]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="客户类型" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-select allowClear placeholder="请选择" v-decorator="['consumerType', {rules:[{required: true, message: '请输入'}]}]">
                                    <a-select-option :value="1">政府</a-select-option>
                                    <a-select-option :value="2">企业</a-select-option>
                                    <a-select-option :value="3">学校</a-select-option>
                                    <a-select-option :value="4">其他</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="销售人员" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-input placeholder="请输入" v-decorator="['saleMan', {rules:[{required: true, message: '请输入'}]}]"></a-input>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="8">
                            <a-form-item label="销售门店" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-select allowClear placeholder="请选择" v-decorator="['saleShopId', {rules:[{required: true, message: '请输入'}]}]">
                                    <a-select-option v-for="(item, index) in shopList" :key="index" :value="item.value">{{item.label}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="销售日期" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-date-picker
                                    style="width:100%"
                                    showTime
                                    format="YYYY/MM/DD HH:mm"
                                    v-decorator="['selectDate', {rules:[{required: true, message: '请输入'}]}]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <span slot="label">销售类型&nbsp;
                                    <a-tooltip>
                                        <span slot="title">
                                            • 预付款：根据售卖数量计算订单价格；<br>
                                            • 后付款：根据实际兑换数量计算订单价格；<br>
                                            • 赠送：订单价格计为0.00;
                                        </span>
                                        <a-icon type="question-circle-o"/>
                                    </a-tooltip>
                                </span>
                                <a-select allowClear placeholder="请选择" @change="saleTypeChange" v-decorator="['saleType', {rules:[{required: true, message: '请输入'}]}]">
                                    <a-select-option :value="2">预付款</a-select-option>
                                    <a-select-option :value="1">后付款</a-select-option>
                                    <a-select-option :value="0">赠送</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="8">
                            <a-form-item label="销售数量" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-input-number :max="limitNum" :precision="0" style="width: 100%" @change="setSaleNums" placeholder="请输入" v-decorator="['saleNum', {rules:[{required: true, message: '请输入'}]}]"></a-input-number>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="销售单价（元，含税单价）" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-input @input="setSalePrices" placeholder="请输入" v-decorator="['salePrice', {rules:[{required: true, message: '请输入'}]}]"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="备注" :wrapperCol="{span: 22}" :labelCol="{span: 24}">
                                <a-textarea placeholder="请输入" v-decorator="['remark', {rules:[{message: '请输入'}]}]"></a-textarea>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-card>
            <a-card class="mt24">
                <div slot="title" class="companyOrderCreate-content-title flex flex-space-between">
                    <span>兑换商品（必填）</span>
                    <section>
                        <a-radio-group v-model="orderTypes" @change="changeOrderTypes">
                            <a-radio-button value="-1">
                                全部
                            </a-radio-button>
                            <a-radio-button value="1">
                                可售
                            </a-radio-button>
                            <a-radio-button value="0">
                                不可售
                            </a-radio-button>
                        </a-radio-group>
                        <a-input-search class="ml24" placeholder="请输入序列号" style="width: 200px" @search="onSearch" />
                    </section>
                </div>
                <div class="mb24 flex flex-space-between">
                    <div class="">
                        已添加 <span style="color: #ff6d33">{{snInfo.addNum}}</span> 商品 ：可售 <span style="color: #ff6d33">{{snInfo.yesNum}}</span> ，不可售 <span style="color: #ff6d33">{{snInfo.noNum}}</span>
                    </div>
                    <a-button type="primary" @click="isAddGoods = true;limitNum - pagination.total <= 0 ?goodsNum = 0:goodsNum = 1;"> 添加</a-button>
                </div>
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :scroll="{ x: 800 }"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                >
                    <span slot="isSell" slot-scope="a,item">
                        {{['不可售',"可售",""][a]}}
                    </span>
                    <span slot="action" slot-scope="a,item">
                        <a-popconfirm
                            title="确定删除SN吗?"
                            @confirm="deleteSnCode(item.id)"
                            >
                            <a v-if="getBtnByAuth('couponNewDetail')" class="text-primary">删除</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
            <a-card
                :bordered="false"
                title="发售方式"
                class="mt24"
            >
                <div class="mb16">
                    <span class="mr8">商品兑换方式:&nbsp;
                        <a-tooltip>
                            <span slot="title">
                                • 一物一码：每个商品都有唯一的兑换码，兑完即失效；<br>
                                • 通用码：公用的兑换码，兑换数量超过销售数量即失效
                            </span>
                            <a-icon type="question-circle-o"/>
                        </a-tooltip>
                    </span>
                    <a-radio-group required defaultValue="1" v-model="convertType">
                        <a-radio :value="0">
                            一物一码
                        </a-radio>
                        <a-radio :value="1">
                            通用码
                        </a-radio>
                    </a-radio-group>
                </div>
                <div>
                    <span>发放形式&nbsp;
                    <a-tooltip>
                        <span slot="title">
                            兑换礼券发给客户的方式，可多选：<br>
                            • 实体券：通过实体票券介质发给客户；<br>
                            • CSV：以CSV电子表格形式发给客户，由其自行分发或导入系统；<br>
                            • 二维码：以二维码图片形式发给客户，由其自行分发；<br>
                            • 账户直发：提供客户手机号名单，直接将礼券发到客户阿派朗账户；<br>
                            • 短信发送：提供客户手机号名单，将兑换码发到指定手机号；<br>
                            • 邮件推送：提供客户邮件名单，将兑换码发到指定邮件；<br>
                            • 在线链接：生成H5在线链接，供客户在线主动领取或兑换；<br>
                            • API接口：提供对应接口信息，供客户通过接口调用兑换码；
                        </span>
                        <a-icon type="question-circle-o" />
                    </a-tooltip>
                    </span>
                    <a-card class="pt24 pb24" :bordered="false">
                        <a-card-grid @click="selectExchangeMode(item)" v-for="(item, index) in exchangeMode" :key="index" class="companyOrderCreate-exchangeMode mr8 mb8 text-center" :class="{isSelect: item.isSelect}" :hoverable="item.used" :style="item.used?'':'background-color:#f8f8f8'">
                            <div class="font-bigger">{{item.name}}</div>
                            <span class="font-smaller">{{item.tips}}</span>
                        </a-card-grid>
                    </a-card>
                </div>
            </a-card>
            <a-card
                :bordered="false"
                title="附件（非必填）"
                class="mt24"
            >
                <a-upload
                    :multiple="true"
                    :fileList="fileList"
                    @change="handleChange"
                    :beforeUpload="beforeUpload"
                    accept=".PNG,.JPG,.XLS,.doc,.pdf"
                    :customRequest="customRequest"
                >
                    <a-button type="primary">
                        <a-icon type="upload"/>选择文件
                    </a-button>
                </a-upload>
            </a-card>
            <a-card
                :bordered="false"
                class="mt24"
            >
                <section class="flex flex-space-between">
                    <div>
                        <span>订单金额：</span>
                        <span style="font-weight: 500;font-size: 18px">¥ {{saleTotals}}</span>
                    </div>
                    <div>
                        <a-button @click="backToTop" >取消</a-button>
                        <a-button @click="createGroupOrder" type="primary" :disabled="!isCanCreateOrder">提交</a-button>
                    </div>
                </section>
            </a-card>

        </div>
        <a-modal v-model="isShowErrCode" title="" ok-text="确认" cancel-text="取消" @cancel="isShowErrCode=false;errorCode=[]" @ok="isShowErrCode=false;errorCode=[]">
            <p v-for="(item, index) in errorCode" :key="index">{{item}}</p>
        </a-modal>
        <a-modal
            title="添加商品"
            :visible="isAddGoods"
            @ok="addSNList"
            @cancel="handleCancel"
        >
            <a-alert message="实体券建议使用指定序列号添加方式，每次添加不超过100条数据" type="warning" show-icon />
            <div class="mt16">
                <span>商品兑换方式: &nbsp;</span>
                <a-radio-group :defaultValue="1" v-model="exchangeModeRadio">
                    <a-radio :value="1">
                        随机添加
                    </a-radio>
                    <a-radio :value="2">
                        指定序列号
                    </a-radio>
                </a-radio-group>
            </div>
            <div class="mt16" v-if="exchangeModeRadio == 1">
                <span>添加数量: &nbsp;</span>
                <a-input-number v-model="goodsNum" :max="limitNum - pagination.total" :min="0" @change="addGoodsNum" step="1"/>
            </div>
            <div class="mt16 flex flex-align-start flex-start" v-if="exchangeModeRadio == 2">
                <span>添加数量: &nbsp;</span>
                <a-textarea v-model="SNList" placeholder="请输入或粘贴序列卡号，以回车进行分行，支持扫码枪二维码识别序列号" style="width: 350px"/>
            </div>
        </a-modal>
    </content-view>
</template>

<script type="text/javascript">
import exchangeGoods from '../../components/modules/change-code/exchange-goods.component'
import richTextViewer from '@/components/modules/rich-text-viewer.component'
import { mapGetters } from "vuex";
import { Modal } from 'ant-design-vue';
export default {
    name: "companyOrderCreate",
    components: {
        exchangeGoods,
        richTextViewer
    },
    props: {},
    data() {
        const tabListNoTitle = [
            {
                key: '1',
                tab: '概览'
            },
            {
                key: '2',
                tab: '团购订单'
            },
        ]
        const columns = [
            {
                title: "序列号SN",
                dataIndex: "sn",
            },
            {
                title: "是否可售",
                dataIndex: "isSell",
                scopedSlots: { customRender: "isSell" }
            },
            {
                title: "说明",
                dataIndex: "remark"
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
        ];
        return {
            isShowErrCode: false,
            errorCode: [],
            exchangeModeRadio: 1,
            goodsNum: 1,
            SNList: "",
            isAddGoods: false,
            orderTypes: "-1",
            convertType: 0,
            form: this.$form.createForm(this),
            spinning: false,
            columns,
            noTitleKey: '1',
            tabListNoTitle: tabListNoTitle,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 10
            },
            fileList: [],
            exchangeMode: [
                {
                    sendType: 1,
                    name: "实体券",
                    tips: "线下实体卡或券",
                    used: true,
                    isSelect: false,
                },
                {
                    sendType: 2,
                    name: "CSV文件",
                    tips: "发放电子表格",
                    used: true,
                    isSelect: false,
                },
                {
                    sendType: 3,
                    name: "二维码",
                    tips: "发放二维码图片",
                    used: true,
                    isSelect: false,
                },
                {
                    sendType: 4,
                    name: "账户直发",
                    tips: "系统直接发送到账户",
                    used: true,
                    isSelect: false,
                },
                {
                    sendType: 5,
                    name: "短信发放",
                    tips: "兑换口令下发手机",
                    used: true,
                    isSelect: false,
                },
                {
                    sendType: 6,
                    name: "邮件推送",
                    tips: "敬请期待",
                    used: false,
                    isSelect: false,
                },
                {
                    sendType: 7,
                    name: "在线链接",
                    tips: "敬请期待",
                    used: false,
                    isSelect: false,
                },
                {
                    sendType: 8,
                    name: "api接口",
                    tips: "敬请期待",
                    used: false,
                    isSelect: false,
                },
            ],
            snInfo: {
                addNum: 0,
                noNum: 0,
                yesNum: 0,
            },
            shopList: [],
            dataDetail: {},
            goodsId: 0,
            saleType: -1, //销售类型
            saleTotal: 0,
            salePrices: 0,
            saleNums: 0,
            orderId: "",
            limitNum: 0,
        };
    },
    computed: {
        ...mapGetters(["shopId"]),
        saleTotals() {
            if (this.saleType == 0 || this.saleType == -1) {
                this.saleTotal = 0;
            } else if (this.saleType == 1) {
                // this.saleTotal = this.salePrices * this.dataSource.length;
                this.saleTotal = 0;
            } else if (this.saleType == 2) {
                this.saleTotal = this.salePrices * this.saleNums;
            }
            return Number(this.saleTotal).toFixed(2);
        },
        isCanCreateOrder() {
            let exchangeModes = this.exchangeMode.filter( el => el.isSelect);
            return this.dataSource.length && exchangeModes.length;
        }
    },
    methods: {
        saleTypeChange(e) {
            this.saleType = e;
        },
        getCodeNum() {
            this.$api.changeCode.getCodeNum({
                query: {
                    couponId: this.goodsId,
                    orderId: this.orderId,
                }
            }).then( res => {
                this.limitNum = res;
            })
        },
        setSaleNums(data) {
            if (data > this.limitNum) return;
            this.saleNums = data;
        },
        setSalePrices(data) {
            this.salePrices = data.target.value;
        },
        backToTop() {
            this.$router.back();
        },
        changeOrderTypes(e) {
            this.getAddSnList();
        },
        deleteSnCode(id) {
            this.$api.changeCode.deleteSnCode({
                query: {id}
            }).then( res => {
                this.getAddSnList();
            })
        },
        addGoodsNum(e) {
            if (e > this.limitNum - this.pagination.total) {
                this.$message.warning("可售库存不足，请重新选择");
            }
        },
        saveSnList(Snlist) {
            var couponGroupOrderTempSnList = [];
            Snlist.forEach( el => {
                couponGroupOrderTempSnList.push({
                    createTime: el.createTime,
                    orderId: this.orderId,
                    createUser: el.createUser,
                    remark: el.remark,
                    sn: el.sn
                })
            })
            this.$api.changeCode.saveGoodBySN({
                body: couponGroupOrderTempSnList
            }).then( res => {
                this.getAddSnList();
            })
        },
        addSNList() {
            if (this.exchangeModeRadio == 1) {
                this.$api.changeCode.addGoodByNum({
                    query: {
                        couponId: this.goodsId,
                        num: this.goodsNum,
                        orderId: this.orderId
                    }
                }).then( res => {
                    this.saveSnList(res);
                })
            } else if (this.exchangeModeRadio == 2) {
                try {
                    var snList = this.SNList.split("\n");
                } catch (error) {
                    this.$message.error("输入格式错误")
                    return;
                }
                this.$api.changeCode.addGoodBySN({
                    body: {
                        couponId: this.goodsId,
                        snList: snList,
                    }
                }).then( res => {
                    if (!res.flag) {
                        this.errorCode = res.data;
                        this.isShowErrCode = true;
                        return;
                    }
                    this.saveSnList(res.data);
                })
            }
        },
        getAddSnList(sn = undefined) {
            this.$api.changeCode.couponGroupOrderTempSn({
                query: {
                    isSell: this.orderTypes,
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.pageSize,
                    shopId: this.shopId,
                    orderId: this.orderId,
                    sn: sn
                }
            }).then( res => {
                this.snInfo = {
                    addNum: res.addNum,
                    noNum: res.noNum,
                    yesNum: res.yesNum,
                },
                this.dataSource = res.couponGroupOrderTempSns.list || [];
                this.pagination.total = res.couponGroupOrderTempSns.total;
                this.isAddGoods = false;
                this.SNList = "";
                this.goodsNum = 1;
                this.exchangeModeRadio = 1;
            })
        },
        initGroupOrder() {
            this.$api.changeCode.initGroupOrder({
                body: {
                    couponId: this.dataDetail.couponId,
                }
            }).then( res => {
                this.orderId = res.id;
                this.getCodeNum();
            })
        },
        createGroupOrder() {
            let couponGroupOrderSendsList = this.exchangeMode.filter( el => el.isSelect);
            let params = {
                goodCategory: this.dataDetail.goodCategory,
                goodId: this.dataDetail.goodId,
                goodInnerName: this.dataDetail.goodInnerName,
                goodName: this.dataDetail.goodName,
                status: this.dataDetail.status,
                couponId: this.dataDetail.couponId,
                convertType: this.convertType,
                saleTotal: this.saleTotal,
                id: this.orderId,
                couponGroupOrderSendsList,
                couponGroupOrderFileList: this.fileList,
            }
            this.form.validateFields((err, values) => {
                if (err) return;
                values.saleDate = values.selectDate?this.$moment(values.selectDate).format("YYYY-MM-DD"):undefined;
                var shop = this.shopList.find( el => el.value == values.saleShopId);
                if (shop) {
                    values.saleShopName = shop.label;
                }
                this.$api.changeCode.createGroupOrder({
                    body: {
                        ...params,
                        ...values,
                    }
                }).then(res => {
                    if (res && typeof res != "number") {
                        this.$message.success("创建成功");
                        this.backToTop();
                    } else {
                        this.getAddSnList();
                        if (res == -3) {
                            Modal.error({
                                title: '兑换商品数量与销售数量不匹配',
                                content: '请调整数量一致，再重试',
                            });
                        } else if (res == -2) {
                            Modal.error({
                                title: '兑换商品含不可售商品',
                                content: '请先移除不可售兑换商品，再重试',
                            });
                        } else if (res == -1) {
                            Modal.error({
                                title: '兑换礼券无效',
                                content: '兑换礼券被停用或已过期',
                            });
                        }
                    }
                })
            });
        },
        handleCancel() {
            this.isAddGoods = false;
            this.SNList = "";
            this.goodsNum = 1;
        },
        onTabChange(noTitleKey) {
            this.noTitleKey = noTitleKey
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize;
            this.pagination.current = page.current;
            this.getAddSnList();
        },
        onSearch(e) {
            this.getAddSnList(e || undefined);
        },
        // @selectExchangeMode 选择兑换方式
        selectExchangeMode(item) {
            if (item.used) {
                item.isSelect = !item.isSelect;
            }
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        // @beforeUpload 上传
        beforeUpload(file) {
            return true;
        },
        handleChange(info) {
            this.fileList = info.fileList
        },
        customRequest({ onSuccess, onError, onProgress, file }) {
            let formData = new FormData();
            formData.append('file', file);
            this.$api.changeCode.uploadGroupFile({
                body: formData,
                params: {
                    shopId: this.shopId,
                    uploadUserName: sessionStorage.getItem('username')
                }
            }, {
                // 请求额外参数
                header: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: ({ total, uploaded }) => {
                    onProgress({ percent: uploaded / total * 100 })
                }
            }).then(res => {
                this.fileList[this.fileList.length - 1].url = res.url;
                onSuccess();
            })
            .catch(err => {
                onError();
            })
        },
        /**
         * @getShopList 获取门店列表
         */
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                res.forEach((item,index) => {
                    item.label = item.name;
                    item.value = item.id;
                });
                this.shopList = [
                    {
                        label: "总部",
                        value: -1,
                    },
                    ...res
                ];
            });
        },
        getGoodDetail() {
            this.$api.changeCode.exchangeGiftDetails({
                query:  {
                    id: this.goodsId,
                }
            })
            .then(res => {
                this.dataDetail = res;
                this.initGroupOrder();
            });
        },
    },
    created() {
        this.goodsId = this.$route.query.id;
        this.getShopList();
    },
    mounted() {
        this.$refs.companyOrderCreate.$el.scrollIntoView();
        this.getGoodDetail();
    }
}
</script>
<style lang="scss">
.companyOrderCreate {
    &-exchangeMode {
        width: 11.8%;
        border: 1px solid #EEE;
        padding: 15px 0;
        border-radius: 10px;
        cursor:pointer;
        &:last-child {
            margin-right: 0;
        }
        &.isSelect {
            // background: #ff6d33;
            border: 1px solid #ff6d33;
            // color: #FFF;
        }
    }
    &-title {
        h1 {
            font-size: 24px;
        }
        span:nth-of-type(n) {
            font-size: 14px;
            color: rgba(0,0,0,0.85);
        }
        span:nth-of-type(2n) {
            font-size: 14px;
            color: rgba(0,0,0,0.65);
        }
        &-tips {
            width: 100%;
            padding: 5px 10px;
            border-radius: 4px;
            border: 1px solid rgba(255, 229, 143, 1);
            background:rgba(255, 251, 230, 1);
            span:nth-of-type(n) {
                color: rgba(0,0,0,0.85);
            }
            span:nth-of-type(2n) {
                color: #ff6d33;
            }
        }
    }
    &-content {
        &-title {
            font-size: 16px;
            font-weight: 500;
            color: #000;
        }
        &-list {
            p {
                width: 33%;
            }
            span:nth-of-type(1) {
                color: rgba(0,0,0,0.85);
                font-size: 14px;
            }
            span:nth-of-type(2) {
                color: rgba(0,0,0,0.45);
                font-size: 14px;
                margin-top: 5px;
            }
        }
    }
}
</style>
